import { createContext } from "react";

export const userAuthContext = createContext({});